<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            颜色
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入标题" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-select v-model="status" style="margin:0 10px">
                            <el-option
                                v-for="item in statusValue"
                                :key="item[0]"
                                :label="item[1]"
                                :value="item[0]">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="name" label="名称"></el-table-column>
                        
                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>
        </div>
        <el-dialog
            title="商品颜色添加"
            :visible.sync="showModalAdd"
            top='35vh'
            width="400px" :close-on-click-modal='false'>
            <el-form :model="addForm" :rules="rules" ref="addForm">
                <el-form-item label="颜色名称" required prop="name">
                    <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showModalAdd = false">取 消</el-button>
                <el-button type="primary" :loading="loadingAdd" @click="confirmAdd">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="商品颜色修改"
            :visible.sync="showModalEdit"
            top='30vh'
            width="400px" :close-on-click-modal='false'>
            <el-form :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="颜色名称" required prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="颜色状态" required>
                    <el-select v-model="editForm.status" style="width:100%">
                        <el-option
                            v-for="item in statusValue"
                            :key="item[0]"
                            :label="item[1]"
                            :value="item[0]">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showModalAdd = false">取 消</el-button>
                <el-button type="primary" :loading="loadingEdit" @click="confirmEdit">确 定</el-button>
            </div>
        </el-dialog>
        <!-- <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    // import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                loadingAdd:false,
                loadingEdit:false,
                tableData:null,
                addForm:{
                    timeStr:timeStr,
                    staffCode: getStaffCode(),
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    name:''
                },
                editForm:{
                    timeStr:timeStr,
                    staffCode: getStaffCode(),
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    name:'',
                    status:'',
                    goodsColorCode:''
                },
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                },
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
                status:-1,
                statusValue:[[-1,'全部状态'],[1,'正常'],[2,'废弃']],
                imgUrl:this.$imgUrl,
            }
        },
        // components:{
        //     Add,Edit
        // },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            handleEdit(index, row) {
                this.editForm.goodsColorCode = row.goodsColorCode;
                this.editForm.name = row.name;
                this.editForm.status = row.status;
                this.showModalEdit =true
            },
            confirmAdd(){
                this.$refs.addForm.validate((valid) => {
                    if(valid){
                        if(this.loadingAdd){
                            return;
                        }else{
                            this.loadingAdd = true;
                        }
                        this.$axios({
                            method: 'post',
                            url: this.$shopUrl+"GoodsColor/Add",
                            data: this.addForm
                        }).then(
                            (response) => {
                                this.loadingAdd = false;
                                if (response.data.error == 0) {
                                    this.showModalAdd=false
                                    this.getList()
                                }else if(response.data.error == 1){
                                    this.$message.error(response.data.message)
                                }
                            }
                        )
                    }else {
                        return false;
                    }
                })

            },
            confirmEdit(){
                this.$refs.editForm.validate((valid) => {
                    if(valid){
                        if(this.loadingEdit){
                            return;
                        }else{
                            this.loadingEdit = true;
                        }
                        this.$axios({
                            method: 'post',
                            url: this.$shopUrl+"GoodsColor/Edit",
                            data: this.editForm
                        }).then(
                            (response) => {
                                this.loadingEdit = false;
                                if (response.data.error == 0) {
                                    this.showModalEdit=false
                                    this.getList()
                                }else if(response.data.error == 1){
                                    this.$message.error(response.data.message)
                                }
                            }
                        )
                    }else {
                        return false;
                    }
                })
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsColor/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        name:this.name,
                        status:this.status,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 1){
                    return "正常";
                }
                if(row.status == 2){
                    return "废弃";
                }
                return "其它";
            },



        }
    }
</script>

<style scoped>

</style>
